import { mapKeysToCamelCase } from '@skytech/utils'

import { API_ROUTE_ADMIN_ASSETS, API_ROUTE_ADMIN_ASSETS_LEASED } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { AssetOriginal, LeasedAssetOrigin } from './types'

import { filterAndSortOptions } from '../../assets/helpers'

type LeasedOriginal = {
  assets: LeasedAssetOrigin[]
  activeEndingOptions: string[]
}
export async function getAssetList() {
  const assets = await get<AssetOriginal[]>(API_ROUTE_ADMIN_ASSETS)
  const camelCaseAssets = mapKeysToCamelCase(assets)

  return camelCaseAssets
}

export async function getLeasedAssetList() {
  const response = await get<LeasedOriginal>(API_ROUTE_ADMIN_ASSETS_LEASED)
  const assets = {
    assets: response.assets,
    activeEndingOptions: filterAndSortOptions(response.activeEndingOptions),
  }
  const camelCaseAssets = mapKeysToCamelCase(assets)
  return camelCaseAssets
}
